module.exports = __webpack_public_path__ + "img/three-dots-fff.560b0905.svg";